import React from "react";
import aboutImage from "../../assets/tomasz-1.jpg";
import "./InfoPanel.css";

const InfoPanel = () => {
  return (
    <div className="info-panel" id="info-panel-id">
      <div className="info-container">
        <div className="info-image-container">
          <img src={aboutImage} alt="Tomasz — Ekselowe.pl" className="info-icon" />
        </div>
        <div className="info-text-container">
          <p className="info-panel-title">Postaw na sukces z Ekselowe</p>
          <p className="info-panel-subtitle">Nie trać czasu.</p>
          <p className="info-panel-text">
            Czy wiesz, że kluczem do efektywnego zarządzania firmą jest skuteczne wykorzystanie dostępnych
            narzędzi? W Ekselowe.pl doskonale rozumiemy, jak istotne jest posiadanie sprawnych rozwiązań, które
            mogą zrewolucjonizować sposób, w jaki prowadzisz swoją firmę. Dlatego proponujemy nie tylko gotowe
            narzędzia, ale również tworzymy specjalnie dostosowane rozwiązania w Excelu, które optymalizują
            działania Twojej firmy.
          </p>

          <p className="info-panel-why-title">co nas wyróżnia</p>
          <p className="info-panel-why-subtitle">Dlaczego Ekselowe.pl?</p>

          <div className="info-panel-points">
            <div className="info-panel-point">
              <p className="info-panel-point-title">Doświadczenie</p>
              <p className="info-panel-point-text">
                Mamy bogate doświadczenie w projektowaniu narzędzi w Excelu dla różnych branż.
              </p>
            </div>
            <div className="info-panel-point">
              <p className="info-panel-point-title">Indywidualne podejście</p>
              <p className="info-panel-point-text">
                Nie stosujemy podejścia jednego rozmiaru dla wszystkich. Nasze rozwiązania są dostosowane do
                Twoich unikalnych potrzeb.
              </p>
            </div>
            <div className="info-panel-point">
              <p className="info-panel-point-title">Wsparcie</p>
              <p className="info-panel-point-text">
                Oferujemy nie tylko narzędzia, ale także wsparcie i szkolenia, abyś mógł w pełni wykorzystać
                potencjał Excela.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
